import React, { useState, useEffect } from 'react';
import { Layout, Card, Form, Input, Button, Typography, message, Avatar, Divider, Row, Col, Space, Switch } from 'antd';
import { 
  UserOutlined, 
  MailOutlined, 
  PhoneOutlined, 
  SaveOutlined, 
  KeyOutlined,
  EditOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  MessageOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navigation from '../components/Navigation';
import AvatarUpload from '../components/AvatarUpload';
import { useAuth } from '../contexts/AuthContext';

const { Content } = Layout;
const { Title, Text } = Typography;
const { TextArea } = Input;

const Profile = () => {
  const [form] = Form.useForm();
  const [passwordForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [editing, setEditing] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const { updateUser } = useAuth();

  const token = localStorage.getItem('token');
  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
    console.log('🚀 Компонент Profile загружен');
    console.log('🔑 Токен в localStorage:', token ? 'присутствует' : 'отсутствует');
    console.log('👤 Пользователь в localStorage:', currentUser);
    
    if (!token) {
      console.log('❌ Токен отсутствует, перенаправляем на логин');
      navigate('/login');
      return;
    }
    
    console.log('✅ Токен найден, загружаем профиль');
    loadProfile();
  }, [token, navigate]);

  // Логируем изменения состояния пользователя
  useEffect(() => {
    console.log('👤 Состояние пользователя изменилось:', user);
    if (user) {
      console.log('📅 Даты в состоянии:', {
        created_at: user.created_at,
        updated_at: user.updated_at,
        created_at_type: typeof user.created_at
      });
    }
  }, [user]);

  const loadProfile = async () => {
    try {
      console.log('🔍 Загружаем профиль...');
      console.log('📡 Отправляем запрос на:', 'https://limitverify.ru:5000/api/auth/profile');
      console.log('🔑 Токен:', token ? `${token.substring(0, 20)}...` : 'отсутствует');
      
      const response = await axios.get('https://limitverify.ru:5000/api/auth/profile', {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      console.log('✅ Ответ от бекенда получен:');
      console.log('📊 Статус:', response.status);
      console.log('📋 Заголовки:', response.headers);
      console.log('📄 Данные:', response.data);
      console.log('👤 Пользователь:', response.data.user);
      
      console.log('🔄 Устанавливаем пользователя в состояние:', response.data.user);
      setUser(response.data.user);
      form.setFieldsValue({
        firstName: response.data.user.firstName,
        lastName: response.data.user.lastName,
        email: response.data.user.email, // Добавляю email в форму
        phone: response.data.user.phone,
        comment: response.data.user.comment
      });
      
      console.log('🎯 Форма заполнена данными:', {
        firstName: response.data.user.firstName,
        lastName: response.data.user.lastName,
        email: response.data.user.email,
        phone: response.data.user.phone,
        comment: response.data.user.comment
      });
      
      // Логируем даты для отладки
      console.log('📅 Даты пользователя:');
      console.log('  - created_at:', response.data.user.created_at);
      console.log('  - updated_at:', response.data.user.updated_at);
      console.log('  - created_at как Date:', response.data.user.created_at ? new Date(response.data.user.created_at) : 'null');
      console.log('  - updated_at как Date:', response.data.user.updated_at ? new Date(response.data.user.updated_at) : 'null');
      
      // Детальное логирование всех полей пользователя
      console.log('🔍 Все поля пользователя:', Object.keys(response.data.user));
      console.log('📋 Значения всех полей:', response.data.user);
      
    } catch (error) {
      console.error('❌ Ошибка при загрузке профиля:', error);
      console.error('📊 Статус ошибки:', error.response?.status);
      console.error('📄 Данные ошибки:', error.response?.data);
      console.error('🔍 Полная ошибка:', error);
      
      if (error.response?.status === 401) {
        console.log('🚫 Неавторизован, перенаправляем на логин');
        navigate('/login');
      }
    }
  };

  const handleEdit = () => {
    setEditing(true);
  };

  const handleCancel = () => {
    setEditing(false);
    form.setFieldsValue({
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.phone,
      comment: user.comment
    });
  };

  const handleSave = async () => {
    try {
      console.log('💾 Сохраняем профиль...');
      const values = await form.validateFields();
      console.log('📝 Данные для сохранения:', values);
      
      setLoading(true);

      const response = await axios.put('https://limitverify.ru:5000/api/auth/profile', values, {
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log('✅ Профиль обновлен успешно:');
      console.log('📊 Статус:', response.status);
      console.log('📄 Ответ:', response.data);
      console.log('👤 Обновленный пользователь:', response.data.user);

      message.success('Профиль обновлен успешно!');
      setUser(response.data.user);
      setEditing(false);
      
      // Обновляем данные в localStorage
      localStorage.setItem('user', JSON.stringify(response.data.user));
      console.log('💾 localStorage обновлен');
      
    } catch (error) {
      console.error('❌ Ошибка при обновлении профиля:', error);
      console.error('📊 Статус ошибки:', error.response?.status);
      console.error('📄 Данные ошибки:', error.response?.data);
      
      if (error.response?.data?.error) {
        message.error(error.response.data.error);
      } else {
        message.error('Ошибка при обновлении профиля');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async () => {
    try {
      console.log('🔐 Изменяем пароль...');
      const values = await passwordForm.validateFields();
      console.log('📝 Данные для изменения пароля:', { ...values, newPassword: '***' });
      
      setPasswordLoading(true);

      const response = await axios.put('https://limitverify.ru:5000/api/auth/change-password', values, {
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log('✅ Пароль изменен успешно:');
      console.log('📊 Статус:', response.status);
      console.log('📄 Ответ:', response.data);

      message.success('Пароль изменен успешно!');
      passwordForm.resetFields();
      
    } catch (error) {
      console.error('❌ Ошибка при изменении пароля:', error);
      console.error('📊 Статус ошибки:', error.response?.status);
      console.error('📄 Данные ошибки:', error.response?.data);
      
      if (error.response?.data?.error) {
        message.error(error.response.data.error);
      } else {
        message.error('Ошибка при изменении пароля');
      }
    } finally {
      setPasswordLoading(false);
    }
  };

  const handleAvatarChange = (newAvatarUrl) => {
    console.log('🖼️ Аватарка изменена:', newAvatarUrl);
    setUser(prevUser => ({
      ...prevUser,
      avatar_url: newAvatarUrl
    }));
    
    // Обновляем данные в AuthContext и localStorage
    updateUser({ avatar_url: newAvatarUrl });
  };

  // Логируем данные пользователя при рендере для отладки
  console.log('🎨 Рендерим профиль с данными:', {
    user,
    hasCreatedAt: !!user?.created_at,
    hasUpdatedAt: !!user?.updated_at,
    createdDate: user?.created_at ? new Date(user.created_at) : null,
    updatedDate: user?.updated_at ? new Date(user.updated_at) : null
  });

  if (!user) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Navigation />
        <Content style={{ padding: '24px', background: '#f0f2f5' }}>
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <Text>Загрузка профиля...</Text>
          </div>
        </Content>
      </Layout>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Navigation />
      
      <Content style={{ padding: '24px', background: '#f0f2f5' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {/* Заголовок */}
          <div style={{ marginBottom: '24px' }}>
            <Title level={2}>Профиль</Title>
            <Text type="secondary">Управление профилем пользователя</Text>
          </div>

          <Row gutter={[24, 24]}>
            {/* Основная информация */}
            <Col xs={24} lg={16}>
              <Card 
                title="Основная информация"
                extra={
                  editing ? (
                    <Space>
                      <Button onClick={handleCancel}>Отмена</Button>
                      <Button 
                        type="primary" 
                        icon={<SaveOutlined />}
                        loading={loading}
                        onClick={handleSave}
                      >
                        Сохранить
                      </Button>
                    </Space>
                  ) : (
                    <Button 
                      type="primary" 
                      icon={<EditOutlined />}
                      onClick={handleEdit}
                    >
                      Редактировать
                    </Button>
                  )
                }
              >
                <Form
                  form={form}
                  layout="vertical"
                  disabled={!editing}
                >
                  <Row gutter={16}>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="firstName"
                        label="Имя"
                        rules={[{ required: true, message: 'Пожалуйста, введите имя!' }]}
                      >
                        <Input 
                          prefix={<UserOutlined />} 
                          placeholder="Имя"
                          size="large"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="lastName"
                        label="Фамилия"
                        rules={[{ required: true, message: 'Пожалуйста, введите фамилию!' }]}
                      >
                        <Input 
                          prefix={<UserOutlined />} 
                          placeholder="Фамилия"
                          size="large"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item
                    name="email"
                    label="Email"
                  >
                    <Input 
                      prefix={<MailOutlined />} 
                      value={user.email}
                      disabled={true}
                      size="large"
                      style={{ backgroundColor: '#f5f5f5', color: '#666' }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="phone"
                    label="Телефон"
                  >
                    <Input 
                      prefix={<PhoneOutlined />} 
                      placeholder="+7 (999) 123-45-67"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item
                    name="comment"
                    label="Комментарий"
                  >
                    <TextArea 
                      rows={3}
                      placeholder="Дополнительная информация"
                      size="large"
                    />
                  </Form.Item>
                </Form>
              </Card>
            </Col>

            {/* Боковая панель */}
            <Col xs={24} lg={8}>
              {/* Информация о пользователе */}
              <Card 
                title="Информация" 
                style={{ marginBottom: 24 }}
                bodyStyle={{ padding: '24px' }}
              >
                <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                  <AvatarUpload
                    userId={user.id}
                    currentAvatarUrl={user.avatar_url}
                    onAvatarChange={handleAvatarChange}
                    size={80}
                  />
                </div>
                <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                  <Title level={4} style={{ margin: 0 }}>
                    {user.firstName || 'Имя'} {user.lastName || 'Фамилия'}
                  </Title>
                  <Text type="secondary" style={{ fontSize: '14px' }}>
                    {user.email || 'Email не указан'}
                  </Text>
                </div>
                
                <Divider />
                
                <div style={{ marginBottom: '8px' }}>
                  <Text type="secondary">Статус:</Text>
                  <br />
                  <Text strong style={{ color: user.isActive ? '#52c41a' : '#ff4d4f' }}>
                    {user.isActive ? 'Активен' : 'Неактивен'}
                  </Text>
                </div>
                
                <div style={{ marginBottom: '8px' }}>
                  <Text type="secondary">Дата регистрации:</Text>
                  <br />
                  <Text strong>
                    {(() => {
                      console.log('🔍 Рендеринг даты регистрации:', {
                        user: user,
                        created_at: user.created_at,
                        created_at_type: typeof user.created_at,
                        created_at_date: user.created_at ? new Date(user.created_at) : null
                      });
                      return user.created_at ? new Date(user.created_at).toLocaleDateString('ru-RU') : 'Не указана';
                    })()}
                  </Text>
                </div>
                
                {user.updated_at && (
                  <div>
                    <Text type="secondary">Дата обновления:</Text>
                    <Text strong>
                      {user.updated_at ? new Date(user.updated_at).toLocaleDateString('ru-RU') : 'Не указана'}
                    </Text>
                  </div>
                )}
                
                {/* Кнопка подключения Telegram */}
                <div style={{ marginTop: 24, textAlign: 'center' }}>
                  <Button 
                    type="primary" 
                    icon={<MessageOutlined />}
                    size="middle"
                    style={{ 
                      borderRadius: 6,
                      height: 36,
                      paddingLeft: 16,
                      paddingRight: 16,
                      backgroundColor: '#1890ff',
                      borderColor: '#1890ff',
                      fontSize: '13px'
                    }}
                  >
                    Подключить телеграм
                  </Button>
                </div>
              </Card>

              {/* Изменение пароля */}
              <Card 
                title="Безопасность" 
                style={{ marginBottom: 24 }}
                bodyStyle={{ padding: '24px' }}
              >
                <Form
                  form={passwordForm}
                  layout="vertical"
                >
                  <Form.Item
                    name="currentPassword"
                    label="Текущий пароль"
                    rules={[{ required: true, message: 'Введите текущий пароль!' }]}
                  >
                    <Input.Password 
                      prefix={<KeyOutlined />}
                      placeholder="Текущий пароль"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item
                    name="newPassword"
                    label="Новый пароль"
                    rules={[
                      { required: true, message: 'Введите новый пароль!' },
                      { min: 8, message: 'Пароль должен содержать минимум 8 символов!' }
                    ]}
                  >
                    <Input.Password 
                      prefix={<KeyOutlined />}
                      placeholder="Новый пароль"
                      size="large"
                      iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                    />
                  </Form.Item>

                  <Form.Item
                    name="confirmPassword"
                    label="Подтвердите пароль"
                    dependencies={['newPassword']}
                    rules={[
                      { required: true, message: 'Подтвердите новый пароль!' },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('newPassword') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('Пароли не совпадают!'));
                        },
                      }),
                    ]}
                  >
                    <Input.Password 
                      prefix={<KeyOutlined />}
                      placeholder="Подтвердите пароль"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button 
                      type="primary" 
                      icon={<KeyOutlined />}
                      loading={passwordLoading}
                      onClick={handleChangePassword}
                      block
                      size="large"
                    >
                      Изменить пароль
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </Col>
          </Row>
        </div>
      </Content>
    </Layout>
  );
};

export default Profile;
